export const CLOUD_FUNCTIONS = {
  CREATE_PAYMENT_INTENT: 'paymentCreatePaymentIntent',
};
export const PAYMENTS_NODE = 'payment';
